













































































































import { defineComponent, ref } from '@nuxtjs/composition-api'
import { productCompareTrack } from '~/helpers/trackings/24orepro/products';
import useProductPage from '~/composables/useProductPage';
import Accordion from '~/components/solepro/Accordion.vue';
import { getAsJSON } from '~/utils/solepro/CmsComponentAggregator';
import PageBuilderComponent from '~/mixins/solepro/PageBuilderComponent.vue';
import { Logger } from '~/helpers/logger';
import PlanTooltip from './PlanTooltip.vue';
import { setElementWidthByCardsContainer } from '~/utils/helpers/functions';

export default defineComponent({
    components: {
        Accordion,
        PageBuilderComponent,
        PlanTooltip
    },
    props: {
        content: {
            type: String,
            required: true
        },
        editorial:{
            type: Boolean,
            default:false
        },
        inverted:{
            type: Boolean,
            default:false
        },
        customClasses:{
            type: String,
            default:'md:-ml-[54px] md:pl-[53px] md:-mt-14'
        }
    },
    data() {
        return {
            sprite: require('~/assets/solepro/spritemap.svg')
        }
    },
    setup(props) {
        const { product } = useProductPage();
        const benchmark = ref(null);
        const isInverted = ref(false);
        const contentRowStart = 3;
        const contentColumnStart = 4;
        const trackProductCompare = () => productCompareTrack(product.value)
        try {
            const jsonDatas = getAsJSON(props.content);
            isInverted.value = jsonDatas.cssClasses.includes('inverted') || props.inverted
            const datas = jsonDatas.children[0].DOMContent;
            const rows = datas.querySelectorAll('table tr');
            const titles = Array.from(rows[0].children).slice(contentColumnStart, 999).map(el => (el as HTMLElement).innerHTML);
            const mobileTitles = Array.from(rows[2].children).slice(contentColumnStart, 999).map(el => (el as HTMLElement).innerHTML);
            const isAi = Array.from(rows[1].children).slice(contentColumnStart, 999).map(el => (el as HTMLElement).innerHTML?.toLowerCase() == 'si');
            const headings = titles.map((title, idx) => {
                return {
                    title,
                    mobileTitle: mobileTitles[idx],
                    isAi: isAi[idx]
                }
            })
            let features = [];
            let lastGroupIndex = contentRowStart;
            
            for (let i = contentRowStart; i < rows.length; i++) {
                const row = rows[i];
                if (row.children[1].innerHTML?.toLowerCase() == 'si') {
                    lastGroupIndex = i;
                    features[i] = { title: row.children[0].innerHTML, values: [], opened: i == 3 }
                } else {
                    const tooltip = row.children[2].innerHTML;
                    if(!features[lastGroupIndex]){
                    features[lastGroupIndex] = { title: '', values: [], opened: true }
                    }
                    features[lastGroupIndex].values.push({
                        title: row.children[0].innerHTML,
                        isOptional: row.children[3].innerHTML == 'si',
                        tooltip: tooltip && tooltip.trim() == '&nbsp;' ? false : row.children[2].innerHTML,
                        values: Array.from(row.children).slice(contentColumnStart, 999).map(el => (el as HTMLElement).innerHTML.toLowerCase() == 'si')
                    })
                }
            }

            benchmark.value = {
                headings,
                features: features.filter(el => !!el)
            }

        } catch (err) {
            Logger.error('Error retrieving PlansBenchmark datas', err)
        }
        return {
            columnsLength: benchmark.value?.headings.length + 1,
            colWidth: 100 / (0.3 + benchmark.value?.headings.length + 1),
            benchmark,
            product,
            trackProductCompare,
            divAOriginalTop: 0,
            scrollBinded: false,
            isInverted

        }
    },

    mounted() {
        const pb = this.$el.querySelector('#plans-benchmark') as HTMLElement;
        setElementWidthByCardsContainer(pb, this.editorial)

        if (window.innerWidth < 1024) {
            window.addEventListener('scroll', this.handleScroll);
            this.scrollBinded = true;
            const divA = this.$refs.stickyThead as HTMLElement;
            this.divAOriginalTop = divA.offsetTop;
        }

        window.addEventListener('resize', this.handleResize)

    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.handleScroll)
        window.removeEventListener('resize', this.handleResize)

        this.scrollBinded = false;
    },
    methods: {
        handleResize() {
            const pb = this.$el.querySelector('#plans-benchmark') as HTMLElement;
            setElementWidthByCardsContainer(pb)
            if (window.innerWidth < 1024) {
                if (!this.scrollBinded) {
                    window.addEventListener('scroll', this.handleScroll)
                    this.scrollBinded = true
                };
            } else {
                window.removeEventListener('scroll', this.handleScroll)
                this.scrollBinded = false;
            }
        },
        handleScroll() {
            const divA = this.$refs.stickyThead as HTMLElement;
            const divB = document.querySelector('.sticky-bar');
            // Ottiene la posizione corrente dello scroll della finestra
            const scrollPosition = window.scrollY || window.pageYOffset;

            const divBComputedStyle = getComputedStyle(divB);
            const divBBottom = parseInt(divBComputedStyle.height.replace('px', '')) + parseInt(divBComputedStyle.top.replace('px', ''))

            // Calcola la posizione dove il divA dovrebbe diventare sticky
           
            const tables = (this.$refs.plansBenchmark as HTMLElement).querySelectorAll('table')
            const rect = tables[1].getBoundingClientRect()
            const topPosition = rect.top
            const triggerPoint = topPosition < divBBottom;
            const tableHeaderHeight = tables[0].getBoundingClientRect().height
            const triggerOffPoint = topPosition < - rect.height + divBBottom + tableHeaderHeight 
            // Controlla se l'utente ha scrollato abbastanza da far diventare divA sticky
            if (triggerPoint && !triggerOffPoint) {
                // Aggiungi la classe sticky-divA se non è già presente
                if (!divA.classList.contains('stickyThead')) {
                    divA.classList.add('stickyThead');
                }
                
            } else {
                // Rimuovi la classe sticky-divA se è presente
                if (divA.classList.contains('stickyThead')) {
                    divA.classList.remove('stickyThead');
                }
            }
        }
    }
})
